import { jsx as _jsx } from "react/jsx-runtime";
import { Label } from "@headlessui/react";
function WPQTLabel({ children, className }) {
    return (_jsx(Label, { className: `wpqt-mb-2 wpqt-block ${className}`, children: children }));
}
export { WPQTLabel };
